import script from "./Disc.vue?vue&type=script&setup=true&lang=js"
export * from "./Disc.vue?vue&type=script&setup=true&lang=js"

import "./Disc.vue?vue&type=style&index=0&id=1d8bbdae&scoped=true&lang=css"

import exportComponent from "/home/runner/work/tests-frontend/tests-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d8bbdae"]])

export default __exports__